import { render } from "./BannerMessage.vue?vue&type=template&id=9f1d9cbc&scoped=true"
import script from "./BannerMessage.vue?vue&type=script&lang=js"
export * from "./BannerMessage.vue?vue&type=script&lang=js"

import "./BannerMessage.vue?vue&type=style&index=0&id=9f1d9cbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1d9cbc"]])

export default __exports__